module.exports = {"231221100":"望奎镇","231221101":"通江镇","231221102":"卫星镇","231221103":"海丰镇","231221104":"莲花镇","231221105":"惠七满族镇","231221106":"先锋镇","231221107":"火箭镇","231221108":"东郊镇","231221202":"灵山满族乡","231221203":"后三乡","231221207":"灯塔乡","231221209":"东升乡","231221210":"恭六乡","231221211":"厢白满族乡","231221400":"白四林场","231221580":"种畜场","231221581":"第一良种场","231221582":"第二良种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231221.json
// module id = 733
// module chunks = 0